module.exports = __webpack_public_path__ + "img/hotel10.9d09a910.png";